import script from "./LightGroupItem.vue?vue&type=script&setup=true&lang=js"
export * from "./LightGroupItem.vue?vue&type=script&setup=true&lang=js"

import "./LightGroupItem.vue?vue&type=style&index=0&id=cd83f702&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd83f702"]])

export default __exports__